// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"552":"db8ab68c","1772":"37cd364b","2760":"db8ab68c","2924":"f8e6c114","8257":"37cd364b","9425":"37cd364b"}[chunkId] + ".chunk.css";
};